import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import CloudfiMusicLogo from './components/CloudfiMusicLogo';
import Home from './pages/Home';
import Artists from './pages/Artists';
import ArtistDetail from './pages/ArtistDetail';
import Releases from './pages/Releases';
import About from './pages/About';
import Contact from './pages/Contact';
import MusicPolicy from './pages/MusicPolicy';
import ReleasePolicy from './pages/ReleasePolicy';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import CookiePolicy from './pages/CookiePolicy';
import DemoSubmission from './pages/DemoSubmission';
import Licensing from './pages/Licensing';
import FAQ from './pages/FAQ';
import Careers from './pages/Careers';
import './App.css';

function CustomBadge() {
  return (
    <div className="custom-badge">
      <CloudfiMusicLogo size={18} />
      <span>Made with CloudfiMusic team</span>
    </div>
  );
}

function App() {
  return (
    <Router>
      <div className="app">
        <Navbar />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/artists" element={<Artists />} />
            <Route path="/artists/:spotifyId" element={<ArtistDetail />} />
            <Route path="/releases" element={<Releases />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/music-policy" element={<MusicPolicy />} />
            <Route path="/release-policy" element={<ReleasePolicy />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
            <Route path="/demo-submission" element={<DemoSubmission />} />
            <Route path="/licensing" element={<Licensing />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/careers" element={<Careers />} />
          </Routes>
        </main>
        <Footer />
        <CustomBadge />
      </div>
    </Router>
  );
}

export default App;
